import React, { useState, useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import styles from './styles.module.css';
import api from '../../service/api';

export default function RequestRecoveryPassword(){

    const [ loading, setLoading ] = useState(false);
    const [ requested, setRequested ] = useState(false);
    const [ email, setEmail ] = useState('');

    const toast = useRef(null);
    const history = useHistory();

    const handleRequestRecoveryPassword = () => {
        if(email.trim() == '')
            return toast.current.show({severity:'warn', summary: 'Atenção', 
            detail: 'Preecha o e-mail para conseguir recuperar a sua senha', life: 6000});

        setLoading(true);
        api().post("/users/recovery/password", { email }).then(response => {
            if(response.status == 200 && response.data.result){
                setRequested(true);
            } else 
                toast.current.show({severity:'error', summary: 'Atenção', 
                    detail: response.data.message, life: 6000});

            setLoading(false);
        });
    }

    const RequestedSuccessfully =  () => (
        <Card className={styles.card}>
            <h5 className="p-success" style={{ textAlign: 'center', color: '#188A42' }}>
                <strong>As instruções para recuperar a sua senha foi enviado para o e-mail</strong>
            </h5>
            <h4 style={{ textAlign: 'center' }}>{email}</h4>
            <p>Você está a poucos passos para recuperar a sua conta. Caso tenha alguma dificuldade, entre em contato
                pelos nossos meios de comunicação!
            </p>
            <div style={{ textAlign: 'center' }}>
                <Button label="Acessar sua conta" className="p-button-rounded" onClick={() => history.push("/")} />
            </div>
        </Card>
    );

    if(requested) return (
        <div className={styles.container}>
            <RequestedSuccessfully />
        </div>
    );

    return (
        <div className={styles.container}>
            <Toast ref={toast} position="top-right" />
            <Card className={styles.card}>
                
                <div className={styles.fields}>
                    <div>
                        <h3>Redefina sua senha</h3>
                    </div>
                    <div>   
                        <label htmlFor="password1" className="block">Informe o e-mail cadastrado para encontramos sua conta!</label>
                        <InputText placeholder="E-mail cadastrado" disabled={loading} value={email} type="email" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                  
                    <div>
                        <Button loading={loading} label={loading ? 'Aguarde...' : 'Recuperar'} className="p-button-rounded" onClick={handleRequestRecoveryPassword} />
                    </div>
                    <div>           
                        <Link to='/'>Acesse sua conta aqui!</Link>
                    </div> 
                </div>
            </Card>
        </div>
    )
}
    